import React, { useState, useImperativeHandle, useEffect } from 'react'
import { Tabs, Tab } from '@mui/material'
import { Colors } from 'Theme'
import { IFTabs } from 'Components'
import CountriesPageTabsSkeleton from './CountriesPageTabsSkeleton'
const tabTitles = {
  Countries: 'Countries',
}

const CountriesPageTabs = React.forwardRef(
  (
    {
      onValueChange,
      isLoading,
      initialIndex,
      CountriesCount,
      fetchListRequestState,
    },
    ref,
  ) => {
    const [selectedIndex, setSelectedIndex] = useState(initialIndex)
    useEffect(() => {
      setSelectedIndex(initialIndex)
    }, [initialIndex])
    const handleChange = (event, newValue) => {
      setSelectedIndex(newValue)
      onValueChange(newValue)
    }

    const resetIndex = () => {
      setSelectedIndex(0)
    }

    useImperativeHandle(ref, () => ({
      resetIndex,
    }))

    return (
      <div>
        {isLoading ? (
          <CountriesPageTabsSkeleton
            tabsCount={Object.keys(tabTitles).length}
          />
        ) : (
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: Colors.primary,
              },
            }}
          >
            {Object.entries(tabTitles).map(([key, title], index) => (
              <Tab
                sx={{
                  padding: '0px',
                  minWidth: 'fit-content',
                  maxWidth: 'fit-content',
                }}
                key={index}
                label={
                  <IFTabs
                    title={title}
                    isSelected={selectedIndex === index}
                    fetchListRequestState={fetchListRequestState}
                    count={key === tabTitles.Countries ? CountriesCount : 0}
                  />
                }
              />
            ))}
          </Tabs>
        )}
      </div>
    )
  },
)

export default CountriesPageTabs
